'use strict'

module.exports = {
  httpClient: 'httpClient',
  windowIpfs: 'windowIpfs',
  jsIpfs: 'jsIpfs',
  webExt: 'webExt'
}
